import { toast } from "react-toastify";
import FarmerClient from "../../../api/farmer";

export const farms = {
  state: {
    farms: [],
    filteredFarm: null,
  },
  reducers: {
    setFilteredFarm(state, payload) {
      localStorage.setItem('selectedFarm', JSON.stringify(payload));
      return {
        ...state,
        filteredFarm: payload,
      };
    },
    setFarms(state, payload) {
      return {
        ...state,
        farms: payload,
      };
    },

    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async setFarmsAsync(payload, rootState) {
      try {
        const res = await FarmerClient.listByLoggedFarmer();
        const { data } = res;
        this.setFarms(data);
        if (data && data.length === 1) {
          this.setFilteredFarm(data[0]);
        } else {
          const selectedFarm = await localStorage.getItem('selectedFarm');
          if (selectedFarm) {            
            this.setFilteredFarm(JSON.parse(selectedFarm));
          }
        }
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
  }),
};
